<div class="modal-overlay" *ngIf="isVisible">
  <div class="modal-content">
    <div class="modal-icon">
      <ng-container *ngIf="isSuccess; else errorTemplate">
        <i class="fas fa-check-circle success-icon"></i>
      </ng-container>
      <ng-template #errorTemplate>
        <i class="fas fa-times-circle error-icon"></i>
      </ng-template>
    </div>
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
    <button class="ok-button" (click)="closeModal()">OK</button>
  </div>
</div>
